import { Link } from "react-router-dom";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="container-px pt-16 md:pt-24 pb-16">
        <div className="max-w-3xl">
          <div className="overline mb-6">About</div>
          <h1 className="font-heading text-5xl md:text-6xl font-light tracking-tight text-ink leading-[1.05]">
            A forum built on <span className="italic text-brand">service, trust</span> and togetherness.
          </h1>
          <p className="mt-8 text-lg text-ink-soft leading-relaxed">
            Oswal Sabha Professional Forum brings together Oswal professionals, families, and well-wishers so we can learn from each
            other, help one another, and keep our values alive through everyday work and community service.
          </p>
        </div>
      </section>

      <section className="container-px pb-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { t: "Mission", d: "Bring our professional strengths into simple, useful support for the community." },
            { t: "Vision", d: "A connected Oswal family across India and the world, growing together with shared values." },
            { t: "Values", d: "Kindness, responsibility, good work, and respect for our heritage." },
          ].map((x, i) => (
            <div key={i} className="card-premium" data-testid={`about-pillar-${i}`}>
              <div className="overline mb-4">{x.t}</div>
              <p className="text-ink leading-relaxed">{x.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="container-px pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="overline mb-4">What we do</div>
            <h2 className="font-heading text-4xl font-light text-ink leading-tight">
              Practical support, meaningful connections, and community action.
            </h2>
            <p className="mt-4 text-ink-soft leading-relaxed">
              We keep the forum focused on useful work that helps members connect, learn, and contribute in real ways.
            </p>
          </div>
          <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              {
                t: "Connect members",
                d: "Help professionals discover one another, start conversations, and build a dependable network.",
              },
              {
                t: "Share learning",
                d: "Organize talks, meetups, and useful sessions that members can apply in daily life and work.",
              },
              {
                t: "Support welfare",
                d: "Create a place where members can request help, contribute resources, and support causes together.",
              },
              {
                t: "Show community work",
                d: "Highlight events, photos, and updates so everyone can see what the forum is doing.",
              },
            ].map((m, i) => (
              <div key={i} className="card-premium" data-testid={`about-focus-${i}`}>
                <div className="overline mb-4">Focus {i + 1}</div>
                <h3 className="font-heading text-xl font-medium text-ink">{m.t}</h3>
                <p className="text-ink-soft mt-2 leading-relaxed">{m.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="container-px pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-stretch">
          <div className="lg:col-span-7 card-premium overflow-hidden">
            <div className="overline mb-4">Activities</div>
            <h2 className="font-heading text-4xl font-light text-ink max-w-2xl">
              A place to share our events, photos, and community moments.
            </h2>
            <p className="mt-4 text-ink-soft leading-relaxed max-w-2xl">
              We added a dedicated Activities section so members and visitors can easily see
              what the forum is doing and what is coming next.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/activities" className="btn-primary inline-flex">
                See activities
              </Link>
              <Link to="/contact" className="btn-secondary inline-flex">
                Share something
              </Link>
            </div>
          </div>
          <div className="lg:col-span-5 grid grid-cols-2 gap-4">
            {[
              "/crowd.jpeg",
              "/president.jpeg",
              "/panal.jpeg",
              "/oaath.jpeg",
            ].map((src, i) => (
              <img
                key={i}
                src={src}
                alt={`Activities highlight ${i + 1}`}
                className="h-40 w-full rounded-2xl object-cover shadow-sm"
              />
            ))}
          </div>
        </div>
      </section>

      <section className="container-px pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="overline mb-4">Trust & Contact</div>
            <h2 className="font-heading text-4xl font-light text-ink leading-tight">
              Ownership & Verification Information
            </h2>
            <p className="mt-4 text-ink-soft leading-relaxed">
              We operate with transparency and clear accountability. OSPF is governed by the senior council of Oswal Sabha, Udaipur.
            </p>
          </div>
          <div className="lg:col-span-8 card-premium grid grid-cols-1 md:grid-cols-2 gap-8 bg-white">
            <div>
              <h3 className="font-heading text-lg font-semibold text-ink mb-2">Registered Address</h3>
              <p className="text-sm text-ink-soft leading-relaxed">
                Oswal Sabha Professional Forum<br />
                Oswal Bhawan, Mukherji Chowk,<br />
                Udaipur - 313001, Rajasthan, India
              </p>
            </div>
            <div>
              <h3 className="font-heading text-lg font-semibold text-ink mb-2">Official Contacts</h3>
              <p className="text-sm text-ink-soft leading-relaxed">
                <strong>Email:</strong> <a href="mailto:oswalsabhaprofessionalforum@gmail.com" className="text-orange-600 hover:underline">oswalsabhaprofessionalforum@gmail.com</a><br />
                <strong>Support:</strong> <a href="tel:+919414156086" className="text-orange-600 hover:underline">+91 94141 56086</a>
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="container-px pb-24">
          <div className="rounded-3xl bg-cream-deep p-10 md:p-16 text-center">
            <div className="overline mb-4">Stand with us</div>
            <h2 className="font-heading text-4xl md:text-5xl font-light text-ink max-w-2xl mx-auto">
            Your time, experience, and support can make a real difference.
            </h2>
          <Link to="/membership" className="btn-primary mt-8 inline-flex" data-testid="about-cta-btn">
            Become a member
          </Link>
        </div>
      </section>
    </div>
  );
}
